import * as bootstrap from 'bootstrap';
import jsKit from './jsKit';
import Cookies from 'js-cookie';
import { swipers } from './swipers';
import { initChoices } from './choices';
import { createGA4Event } from './spGa4';

let productZoomPromise = null;

const loadProductZoom = () => {
  if (!productZoomPromise) {
    productZoomPromise = Promise.all([
      import(/* webpackChunkName: "product-zoom" */ 'inner-image-zoom'),
      import(/* webpackChunkName: "product-zoom" */ 'vanilla-lazyload'),
    ]).then(([innerImageZoom, lazyLoad]) => ({
      InnerImageZoom: innerImageZoom.default || innerImageZoom,
      LazyLoad: lazyLoad.default || lazyLoad,
    }));
  }

  return productZoomPromise;
};
const sp = (() => {
  const defaults = {
    debugMode: false,
  };

  const pathSegments = new Set();

  return {

    pushToDataLayer: (data) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(data);
    },

    GA4Event: createGA4Event((data) => sp.pushToDataLayer(data)),

    priceToggle: (e) => {
      const trigger = e.delegateTarget || e.currentTarget;
      const hidePriceDetails = Cookies.get('price_details_hidden') !== '1';

      document.querySelectorAll('#catalogue-price, #wholesale_price_net, #wholesale_price_gross, #wholesale_price_info')
        .forEach((element) => element.classList.toggle('d-none', hidePriceDetails));
      document.querySelectorAll('#catalogue-price, #wholesale_price_net, #wholesale_price_gross, #wholesale_price_info')
        .forEach((element) => element.classList.toggle('d-flex', !hidePriceDetails));
      document.getElementById('price_regular')?.classList.toggle('d-none', !hidePriceDetails);
      document.getElementById('price_regular')?.classList.toggle('d-flex', hidePriceDetails);
      document.querySelectorAll('[data-price="toggle-regular-price"]').forEach((element) => {
        element.style.display = hidePriceDetails ? '' : 'none';
      });
      document.querySelectorAll('[data-price="toggle-wholesale-price"]').forEach((element) => {
        element.style.display = hidePriceDetails ? 'none' : '';
      });

      if (Cookies.get('_cookieSettingsCustom')) {
        Cookies.set('price_details_hidden', hidePriceDetails ? '1' : '0', { path: '/' });
      }

      trigger.checked = !hidePriceDetails;
    },

    changeCurrency: async (e) => {
      const trigger = e.delegateTarget || e.currentTarget;
      const formData = new FormData();
      formData.set('change_currency[currency]', trigger.value);

      const data = await jsKit.requestUrl('/main/changeCurrency/', 'json', 'POST', formData);
      if (data?.validated) {
        window.location.reload();
      } else {
        jsKit.showErrors(data, 'body');
      }
    },

    setLanguage: async (e) => {
      const trigger = e.delegateTarget || e.currentTarget;
      await jsKit.requestUrl(`/main/setLanguage/${encodeURIComponent(trigger.value)}`, 'text');
      window.location.reload();
    },

    sendProductQuestion: async (e) => {
      e.preventDefault();

      const trigger = e.delegateTarget || e.currentTarget;
      const form = trigger.closest('form');
      if (!form) {
        return;
      }

      jsKit.setLoading(trigger, true, { disabled: true });
      const data = await jsKit.requestUrl('/product/sendQuestion', 'json', 'POST', new FormData(form));
      jsKit.setLoading(trigger, false, { disabled: true });

      if (!data?.validated) {
        jsKit.showErrors(data, form);
        return;
      }

      const contentInput = form.querySelector('#qaContent');
      if (contentInput) {
        contentInput.value = '';
      }
      jsKit.showNotificationsPanel(data.success_message, 'success');
      jsKit.closeModal();
    },

    subscribeNewsletter: async (e) => {
      e.preventDefault();

      const trigger = e.delegateTarget || e.currentTarget;
      const form = trigger.closest('form');
      if (!form) {
        return;
      }

      jsKit.setLoading(trigger, true, { disabled: true });
      const data = await jsKit.requestUrl('/newsletter/subscribe', 'json', 'POST', new FormData(form));
      jsKit.setLoading(trigger, false, { disabled: true });

      if (!data?.validated) {
        jsKit.showErrors(data, form);
        return;
      }

      const emailInput = form.querySelector('#newsletter-subscribe-email');
      if (emailInput) {
        emailInput.value = '';
      }
      jsKit.showNotificationsPanel(data.success_message, 'success');
    },

    saveUnavailableProductForm: async (e) => {
      e.preventDefault();

      const trigger = e.delegateTarget || e.currentTarget;
      const form = trigger.closest('form');
      if (!form) {
        return;
      }

      jsKit.setLoading(trigger, true, { disabled: true });
      const data = await jsKit.requestUrl('/product/saveUnavailableProductForm', 'json', 'POST', new FormData(form));
      jsKit.setLoading(trigger, false, { disabled: true });

      if (!data?.validated) {
        jsKit.showNotificationsPanel(data?.error_message, 'error');
        return;
      }

      const unavailableEmailInput = form.querySelector('#unavailable_product_email');
      if (unavailableEmailInput) {
        unavailableEmailInput.value = '';
      }
      jsKit.showNotificationsPanel(data.success_message, 'success');
    },

    navBarDropdown: (e) => {
      const dropdowns = document.querySelectorAll('.navbar .dropdown-toggle');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const playHoverVideo = (video) => {
        if (reducedMotion.matches) {
          return;
        }

        if (!video.src) {
          video.src = video.dataset.hoverVideoSrc;
          video.load();
        }

        video.play().catch(() => {});
      };

      const initHoverVideos = (dropdown) => {
        dropdown.parentElement.querySelectorAll('[data-hover-video-src]').forEach((video) => {
          const tile = video.closest('.dropdown-bg');
          if (!tile) {
            return;
          }

          tile.addEventListener('pointerenter', () => playHoverVideo(video));
          tile.addEventListener('pointerleave', () => {
            video.pause();
            video.currentTime = 0;
          });
          tile.addEventListener('focusin', () => playHoverVideo(video));
          tile.addEventListener('focusout', (event) => {
            if (!tile.contains(event.relatedTarget)) {
              video.pause();
              video.currentTime = 0;
            }
          });
        });
      };

      dropdowns.forEach((dropdown) => {
        new bootstrap.Dropdown(dropdown);
        initHoverVideos(dropdown);
        dropdown.addEventListener('shown.bs.dropdown', event => {
          setTimeout(() => dropdown.classList.add('fade-in'), .1);
        });
        dropdown.addEventListener('hidden.bs.dropdown', event => {
          dropdown.classList.remove('fade-in');
        });
      });
    },

    tabsHash: () => {
      const hash = window.location.hash;
      const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
      if (hash && tabLinks.length) {
        const tabTriggerEl = document.querySelector(`a.nav-link[href="${hash}"]`);

        if (tabTriggerEl) {
          const tab = new bootstrap.Tab(tabTriggerEl);
          tab.show();
          tabTriggerEl.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }

      tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('shown.bs.tab', (event) => {
          history.replaceState(null, null, event.target.getAttribute('href'));
          event.target.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        });
      });
    },

    appModal: () => {

      const appModalElem = document.querySelector('#app-change-modal');
      if (!appModalElem) {
        return;
      }

      const appModal = new bootstrap.Modal(appModalElem);

      if (!Cookies.get('appAlertOff')) {
        if ((jsKit.getAppId() === '1' && !jsKit.isNavigatorPl()) || (jsKit.getAppId() === '5' && jsKit.isNavigatorPl())) {
          appModal.show();
        }
      }

      appModalElem.addEventListener('hidden.bs.modal', () => {
        if (Cookies.get('_cookieSettingsRequired')) {
          Cookies.set('appAlertOff', true, { expires: 30 });
        }
      });
    },

    initJsChoice: () => initChoices(),

    imageZoomInit: async () => {
      if (jsKit.isMobile() || jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm() || jsKit.rwdMedia.md()) {
        return;
      }

      const swiperPhotos = document.querySelector('#swiper-product-photos');
      if (!swiperPhotos) {
        return;
      }

      const { InnerImageZoom, LazyLoad } = await loadProductZoom();
      new LazyLoad();
      new InnerImageZoom('#swiper-product-photos .liz', {
        zoomScale: 0.8,
        zoomType: 'hover',
        fadeDuration: 250,
        fullscreenOnMobile: false,
        hideCloseButton: true,
        hideHint: true,
      });
    },

    // karta produktu - personalizacja
    updatePersonalizationImage: async (e) => {
      const productId = e.target.dataset.jsUpdatePersonalizationImage;

      const swiperPhotos = document.querySelector('#swiper-product-photos');
      const swiperModalPhotos = document.querySelector('#swiper-modal-product-photos');
      swiperPhotos.classList.add('loading');

      const formData = new URLSearchParams();
      const personalizationInputs = document.querySelectorAll('.personalization-input');
      personalizationInputs.forEach((input) => {
        if (input.value) {
          const key = input.dataset.slot;
          formData.append(`product_personalization[slots][${key}]`, input.value);
        }
      });

      const color = document.querySelector('input[name="colors"]:checked');
      if (color) {
        formData.append('product_personalization[color]', color.value);
      }

      const font = document.querySelector('select[name="fonts"]');
      if (font) {
        formData.append('product_personalization[font]', font.value);
      }

      const url = `/product/previewPersonalizedImage/${productId}`;
      const postCB = (data) => {
        swiperPhotos.classList.remove('loading');
        if (data.validated === 0) {
          //showErrors(data);
        } else {
          //hideErrors();
          const { swiperProductsPhotos, swiperModalProductsPhotos } = swipers.swiperProductCardInit();
          if (data.original === 1) {
            swiperProductsPhotos.slideTo(0);
            swiperPhotos.querySelectorAll('[data-personalization]').forEach((el) => el.remove());
            swiperModalPhotos.querySelectorAll('[data-personalization]').forEach((el) => el.remove());
            const swiperPhotosThumb = document.querySelector('#swiper-thumb-pagination');
            const bullets = swiperPhotosThumb.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((el) => el.remove());
            swiperProductsPhotos.update();
            swiperModalProductsPhotos.update();
          } else {
            if (swiperPhotos.querySelectorAll('[data-personalization]').length === 0) {
              swiperPhotos.querySelector('.swiper-wrapper').insertAdjacentHTML('beforeend', data.preview);
              swiperModalPhotos.querySelector('.swiper-wrapper').insertAdjacentHTML('beforeend', data.thumbnail);
            } else {
              const personalizationElPhoto = swiperPhotos.querySelector('[data-personalization]');
              if (personalizationElPhoto) {
                personalizationElPhoto.outerHTML = data.preview;
              }
              const personalizationElModal = swiperModalPhotos.querySelector('[data-personalization]');
              if (personalizationElModal) {
                personalizationElModal.outerHTML = data.thumbnail;
              }
            }

            const personalizationElPhoto = swiperPhotos.querySelector('[data-personalization]');
            const siblings = Array.from(personalizationElPhoto.parentNode.children);
            personalizationElPhoto.dataset.index = siblings.indexOf(personalizationElPhoto);

            sp.imageZoomInit();

            personalizationElPhoto.addEventListener('click', () => {
              swiperModalProductsPhotos.slideTo(siblings.indexOf(personalizationElPhoto));
            });

            swiperProductsPhotos.update();
            swiperModalProductsPhotos.update();
            swiperProductsPhotos.slideTo(siblings.indexOf(personalizationElPhoto));
          }
        }
      };

      await jsKit.fetchUrl(url, postCB, 'urlencoded', 'POST', formData);
    },

    // karta produktu - wyliczenie czasu dostawy dla produktów dostępnych w Verto i u dostawcy
    calculateFinalDeliveryTime: () => {
      const deliveryContainer = document.querySelector('[data-basket-options-availability-both]');

      if (!deliveryContainer) {
        return;
      }

      const deliveryContainerText = document.querySelector('#productFinalDeliveryTime');
      const productsSizeOption = document.querySelectorAll('[data-availability-option]');
      const deliveryDefault = document.querySelector('#product-delivery-default');
      const deliveryToday = document.querySelector('#product-delivery-today');
      const delivery24 = document.querySelector('#product-delivery-24');
      const deliveryExtended = document.querySelector('#product-delivery-extended');

      let isDeliveryTodayAvailable = false;
      let isDelivery24Available = false;

      const checkDeliveryTime = () => {
        return [...productsSizeOption].filter((item) => item.checked).map((item) => {
          const vertoAmount = parseInt(item.dataset.availabilityV, 10);
          const maxDeliveryTime = parseInt(item.dataset.availabilityDeliveryMax, 10);
          const minDeliveryTime = parseInt(item.dataset.availabilityDeliveryMin, 10);

          let orderAmount = document.querySelector('#product-amount') || document.querySelector(`[data-availability-amount-for-option="${item.dataset.availabilityOption}"]`);
          orderAmount = parseInt(orderAmount.value, 10);

          if (orderAmount > 0) {
            let deliveryTime = maxDeliveryTime;
            if (orderAmount <= vertoAmount) {
              deliveryTime = minDeliveryTime;
              isDelivery24Available = true;
              if (deliveryTime && deliveryToday) {
                isDeliveryTodayAvailable = true;
                isDelivery24Available = false;
              }
            }
            return deliveryTime;
          }
          return 0;
        });
      };

      if (Array.isArray(checkDeliveryTime()) && checkDeliveryTime().length !== 0) {
        const deliveryTime = Math.max(...checkDeliveryTime());

        if (deliveryTime === 1) {
          if (isDeliveryTodayAvailable) { // wysyłka dzisiaj
            deliveryContainerText.innerHTML = deliveryToday.innerHTML;
          } else if (isDelivery24Available) { // wysyłka w 24h
            deliveryContainerText.innerHTML = delivery24.innerHTML;
          }
        } else {
          // wysyłka w dniach
          deliveryContainerText.innerHTML = deliveryExtended.innerHTML.replace('%%days%%', deliveryTime.toString());
          jsKit.initTooltipsIn(deliveryContainerText);
        }

        deliveryContainer.classList.remove('bg-info');
        deliveryContainerText.classList.add('text-primary');
        setTimeout(() => deliveryContainerText.classList.remove('text-primary'), 1200);
      } else {
        // brak zaznaczonego rozmiaru lub ilości
        deliveryContainer.classList.add('bg-info');
        deliveryContainerText.innerHTML = deliveryDefault.innerHTML;
      }
    },

    // karta produktu - wyświetla dostępną ilość
    showStockAmount: (e) => {
      const [content, colorClass] = e.target.dataset.jsShowStockAmount.split(', ');
      const stockCount = document.querySelector('#stock-count');
      if (!stockCount) {
        return;
      }
      stockCount.className = '';
      stockCount.classList.add(colorClass);
      stockCount.innerText = content;
      sp.calculateFinalDeliveryTime();
    },

    // karta produktu
    wholesaleAmountChange: (e) => {
      const isEvent = (param) => param instanceof Event;
      const inputElement = isEvent(e) ? e.target : e;
      if (!inputElement) {
        return null;
      }
      const maxStockAmount = inputElement.dataset.jsWholesaleAmountChange;
      jsKit.sanitizeInteger(inputElement, undefined, parseInt(maxStockAmount, 10));

      const optionId = inputElement.name;

      if (inputElement.value === '0') {
        inputElement.value = '';
      }

      document.querySelector(`#checkbox_${optionId}`).checked = !!inputElement.value;

      sp.calculateFinalDeliveryTime();
    },

    // karta produktu
    sanitizeIntegerBlur: (e) => {
      const [min, max] = e.target.dataset.jsSanitizeIntegerBlur.split(',').map(Number);
      jsKit.sanitizeInteger(e.target, min, max);
    },

    // wyszukiwarka - panel z podpowiedziami
    searchOnEnter: (e) => {
      if (e.key === 'Enter' && e.target.dataset.selectedIndex === '-1') {
        sp.searchProducts();
      }
    },

    // wyszukiwarka - panel z podpowiedziami
    showSearchHints: async (e) => {
      if (jsKit.isMobile() || jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm() || jsKit.rwdMedia.md()) {
        return;
      }

      if (defaults.debugMode) {
        console.log('showSearchHints()');
      }

      let selectedIndex = -1;

      if (!e.target.data) {
        e.target.data = {
          searchSpinner: document.querySelector('#search-input-spinner'),
          resultsContainer: document.querySelector('#panel_search_hints'),
          keydownEvent: false,
          setupAutocomplete: async () => {
            e.target.addEventListener('keydown', (e) => {
              e.target.data.keydownEvent = true;
              const itemsList = e.target.data.resultsContainer.querySelectorAll('.autocomplete-item');
              if (e.key === 'ArrowDown') {
                e.preventDefault();
                selectedIndex = (selectedIndex + 1) % itemsList.length;
                e.target.dataset.selectedIndex = selectedIndex;
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                selectedIndex = (selectedIndex - 1 + itemsList.length) % itemsList.length;
                e.target.dataset.selectedIndex = selectedIndex;
              } else if (e.key === 'Enter' && selectedIndex !== -1) {
                const selectedItem = itemsList[selectedIndex];
                e.target.dataset.selectedIndex = selectedIndex;
                window.location.href = selectedItem.dataset.link;
              } else if (e.key === 'Escape') {
                e.target.blur();
              }

              itemsList.forEach((item, index) => {
                if (index === selectedIndex) {
                  item.classList.add('bg-gray-100');
                } else {
                  item.classList.remove('bg-gray-100');
                }
              });
            });
          },
        };
      }

      const searchPhrase = e.target.value.trim();
      e.target.focus();
      const isSearchEnabled = searchPhrase.length > 3;

      if (isSearchEnabled) {
        e.target.data.searchSpinner.classList.remove('d-none');
        const url = '/main/showSearchHints/';
        const formData = new URLSearchParams();
        formData.append('search_hints[phrase]', searchPhrase);
        const showResult = (data) => {
          if (data.html) {
            e.target.classList.add('is-enabled');
            setTimeout(() => e.target.data.searchSpinner.classList.add('d-none'), 1000);
            e.target.data.resultsContainer.innerHTML = data.html;
            if (e.target.data.keydownEvent === false) {
              e.target.data.setupAutocomplete();
            }
          }
        };

        await jsKit.fetchUrl(url, showResult, 'urlencoded', 'POST', formData);
      } else {
        e.target.classList.remove('is-enabled');
      }
    },

    // wyszukiwarka - wyszukiwanie wpisanej frazy z uwzględnioną kat.
    searchProducts: (e) => {
      const searchInput = document.querySelector('#search-products-phrase');
      const searchPhrase = searchInput.value.trim();

      if (searchPhrase.length > 0) {
        jsKit.addQueryParam('q', searchPhrase);
        // remove pagination when starting a new search
        const searchParams = new URLSearchParams(jsKit.parseCurrentLocation().search);
        if (searchParams.has('page')) {
          jsKit.removeQueryParam('page');
        }

        if (jsKit.parseCurrentLocation().pathname.includes(searchInput.dataset.products)) {
          window.location = `${jsKit.parseCurrentLocation().pathname}${jsKit.parseCurrentLocation().search}`;
        } else {
          window.location = `/${searchInput.dataset.products}${jsKit.parseCurrentLocation().search}`;
        }
      }
    },

    // wyszukiwarka - czyszczenie wyników z wpisanej frazy
    clearSearchProducts: (e) => {
      if (e) {
        e.target.disabled = true;
      }
      const searchInput = document.querySelector('#search-products-phrase');
      searchInput.value = '';
      jsKit.removeQueryParam('q');
      window.location = `${jsKit.parseCurrentLocation().pathname}${jsKit.parseCurrentLocation().search}`;
    },

    // lista produktów, filtry - checkbox dla filtra: Sztuki
    clearAmountInputParam: () => {
      const amountInput = document.querySelector('#amount-min');
      const amountCheckbox = document.querySelector('#check-amount');
      if (!amountCheckbox) {
        return;
      }
      jsKit.removeQueryParam('amountmin');
      amountInput.value = '';
      amountCheckbox.checked = false;
      sp.setAmount();
    },

    // lista produktów, filtry - checkbox dla filtra: Sztuki
    setAmountCheckboxState: () => {
      const amountInput = document.querySelector('#amount-min');
      const amountCheckbox = document.querySelector('#check-amount');
      if (!amountCheckbox) {
        return;
      }
      if ((!amountInput.value || amountInput.value === '0') && amountCheckbox.checked) {
        sp.clearAmountInputParam();
      }
      amountCheckbox.checked = amountInput.value && amountInput.value !== '0';
    },

    // lista produktów, filtry - checkbox dla filtra: Sztuki
    setAmount: () => {
      const amountCheckbox = document.querySelector('#check-amount');
      if (!amountCheckbox) {
        return;
      }
      const amountInput = document.querySelector('#amount-min');
      const amountName = amountInput.getAttribute('name');
      sp.loadCurrentLocationWithNewParam(amountName, amountInput.value);
    },

    // lista produktów, filtry - checkbox dla filtra: Czas
    clearDeliveryTimeInputParam: () => {
      const deliveryCheckbox = document.querySelector('#check-deliveryTime');
      if (!deliveryCheckbox) {
        return;
      }
      jsKit.removeQueryParam('delivery_time');
      [...document.querySelectorAll('.delivery-time-filter')].forEach((item) => item.checked = false);
      deliveryCheckbox.checked = false;
      sp.setDelivery();
    },

    // lista produktów, filtry - checkbox dla filtra: Czas
    setDeliveryTimeCheckboxState: () => {
      const filters = document.querySelector('.delivery-time-filter:checked');
      const deliveryCheckbox = document.querySelector('#check-deliveryTime');
      if (!deliveryCheckbox) {
        return;
      }
      if ([...filters].every((checkbox) => !checkbox.checked) && deliveryCheckbox.checked) {
        sp.clearDeliveryTimeInputParam();
      }
      deliveryCheckbox.checked = [...filters].some((checkbox) => checkbox.checked);
    },

    // lista produktów, filtry - checkbox dla filtra: Czas
    setDelivery: () => {
      const deliveryCheckbox = document.querySelector('#check-deliveryTime');
      if (!deliveryCheckbox) {
        return;
      }
      const opts = [...document.querySelector('.delivery-time-filter:checked')].map((item) => item.value);
      sp.loadCurrentLocationWithNewParam('delivery_time', opts);
    },

    // lista produktów, filtry - checkbox dla filtra: Cena
    clearPriceInputParam: () => {
      const priceFromInput = document.querySelector('#price-from');
      const priceToInput = document.querySelector('#price-to');
      const priceCheckbox = document.querySelector('#check-price');
      if (!priceCheckbox) {
        return;
      }
      jsKit.removeQueryParam('pricefrom');
      jsKit.removeQueryParam('priceto');
      priceFromInput.value = '';
      priceToInput.value = '';
      priceCheckbox.checked = false;
      sp.setPrice();
    },

    // lista produktów, filtry - checkbox dla filtra: Cena
    setPriceCheckboxState: () => {
      const priceFromInput = document.querySelector('#price-from');
      const priceToInput = document.querySelector('#price-to');
      const priceCheckbox = document.querySelector('#check-price');
      if (!priceCheckbox) {
        return;
      }
      if (!priceFromInput.value && !priceToInput.value && priceCheckbox.checked) {
        sp.clearPriceInputParam();
      }
      priceCheckbox.checked = priceFromInput.value || priceToInput.value;
    },

    // lista produktów, filtry - checkbox dla filtra: Cena
    setPrice: () => {
      const priceCheckbox = document.querySelector('#check-price');
      if (!priceCheckbox) {
        return;
      }
      const priceFrom = document.querySelector('#price-from');
      const priceFromName = priceFrom.getAttribute('name');
      const priceTo = document.querySelector('#price-to');
      const priceToName = priceTo.getAttribute('name');
      sp.loadCurrentLocationWithNewPrice(priceFromName, priceFrom.value, priceToName, priceTo.value);
    },

    // lista produktów, filtry - Cena
    loadCurrentLocationWithNewPrice: (paramFromName, paramFromValue = 0, paramToName = '', paramToValue = 0) => {
      sp.productListLoaderOn();
      const newParams = {};
      if (paramFromValue) {
        newParams[paramFromName] = paramFromValue;
      }
      if (paramToName && paramToValue) {
        newParams[paramToName] = paramToValue;
      }

      const requiredParams = sp.getCurrentRequiredParams();
      const params = Object.assign({}, requiredParams, newParams);
      const queryString = new URLSearchParams(params).toString();

      sp.loadContentJson(`${jsKit.parseCurrentLocation().pathname}?${queryString}`);
    },

    // lista produktów, filtry - ilość
    loadCurrentLocationWithNewParam: (paramName, paramValue) => {
      sp.productListLoaderOn();

      const newParams = {};
      if (paramValue) {
        newParams[paramName] = paramValue;
      }

      const requiredParams = sp.getCurrentRequiredParams();
      const params = Object.assign({}, requiredParams, newParams);
      const queryString = new URLSearchParams(params).toString();

      sp.loadContentJson(`${jsKit.parseCurrentLocation().pathname}?${queryString}`);
    },

    // lista produktów,
    getCurrentRequiredParams: () => {

      const searchParams = jsKit.parseCurrentLocation().search;

      const urlParams = new URLSearchParams(searchParams);
      const params = {};

      const searchQuery = urlParams.get('q');
      if (searchQuery) {
        params.q = searchQuery;
      }

      const limit = urlParams.get('limit');
      if (limit) {
        params.limit = limit;
      } else {
        params.limit = 30;
      }

      const priceFrom = urlParams.get('pricefrom');
      if (priceFrom) {
        params.pricefrom = priceFrom;
      }

      const priceTo = urlParams.get('priceto');
      if (priceTo) {
        params.priceto = priceTo;
      }

      const sortBy = urlParams.get('sort_by');
      if (sortBy) {
        params.sort_by = sortBy;
      } else {
        const sorting = document.querySelector('#products-sorting');
        if (sorting) {
          const selectParams = new URLSearchParams(sorting.value.split('?')[1]);
          params.sort_by = selectParams.get('sort_by');
        }
      }

      const amountMin = urlParams.get('amountmin');
      if (amountMin) {
        params.amountmin = amountMin;
      }

      const checkedDeliveryFilters = document.querySelectorAll('.delivery-time-filter:checked');

      if (checkedDeliveryFilters) {
        const opts = [...checkedDeliveryFilters].map((item) => item.value);
        if (opts.length > 0) {
          params.delivery_time = opts;
        }
      }

      return params;
    },

    // lista produktów,
    pathSegments,

    // lista produktów,
    syncPathSegments: () => {
      const segments = jsKit.parseCurrentLocation().pathname.split('/').filter(Boolean).slice(1);
      sp.pathSegments.clear();
      segments.forEach((segment) => sp.pathSegments.add(segment));
    },

    // lista produktów,
    initSegments: () => sp.syncPathSegments(),

    // lista produktów,
    loadProductList: (e) => {
      let url = e.target.dataset.jsLoadProductList;
      e.preventDefault();
      sp.toggleSideMenu('product-filters');
      sp.productListLoaderOn();

      // History API updates the URL before the request finishes. Always use that
      // latest URL as the source of truth instead of a long-lived Set snapshot.
      sp.syncPathSegments();

      if (e.target.id === 'filters-clear') {
        const searchInput = document.querySelector('#search-products-phrase');
        searchInput.value = '';
        jsKit.removeQueryParam('q');
      }

      if (!url) {
        url = e.target.value;
        if (e.target.id === 'products-sorting') {
          jsKit.removeQueryParam('sort_by');
        }
      }

      // Build query string: put `page` first (taken from the clicked URL), then required params
      const urlQuery = url.includes('?') ? url.split('?')[1] : '';
      const currentPage = new URLSearchParams(urlQuery).get('page');
      const sortByFromUrl = new URLSearchParams(urlQuery).get('sort_by');

      const requiredParams = sp.getCurrentRequiredParams();
      if (e.target.tagName === 'SELECT') {
        delete requiredParams.sort_by;
      }
      const qs = new URLSearchParams();

      if (currentPage) {
        delete requiredParams.page;
        if (currentPage !== '1') {
          qs.append('page', currentPage);
        }
      }

      Object.keys(requiredParams).forEach((key) => {
        const value = requiredParams[key];
        if (Array.isArray(value)) {
          value.forEach((v) => qs.append(key, v));
        } else if (value !== undefined && value !== null && value !== '') {
          qs.append(key, value);
        }
      });

      const path = url.split('?')[0];
      const segments = path.split('/').filter(Boolean).slice(1);
      const basePath = path.split('/').filter(Boolean)[0];

      if (e.target.tagName === 'SELECT') {
        qs.append('sort_by', sortByFromUrl);
      } else if (e.target.tagName !== 'A') {
        if (e.target.checked) {
          sp.pathSegments.add(segments[segments.length - 1]);
        } else if (e.target.closest('#filters-current')) {
          for (const value of sp.pathSegments) {
            if (!segments.includes(value)) {
              sp.pathSegments.delete(value);
            }
          }
        } else {
          sp.pathSegments.delete(segments[segments.length - 1]);
        }
      }

      const params = qs.toString();
      const fullPath = `/${basePath}/${Array.from(sp.pathSegments).join('/')}?${params}`;

/*       console.log('path', path);
      console.log('segments', segments);
      console.log('basePath', basePath);
      console.log('pathSegments', sp.pathSegments);
      console.log('params', params);
      console.log('fullPath', fullPath); */

      sp.loadContentJson(fullPath);
    },

    // lista produktów,
    loadContentJson: (url) => {
      if (url) {
        jsKit.loadWithHistory({
          url,
          state: { request: 'json', refresh: Math.random() },
        }, () => {
          sp.setAmountCheckboxState();
          sp.setPriceCheckboxState();
        });

        if (window.scrollY > 340 && document.querySelectorAll('#price-filter-label label').length === 0) {
          jsKit.scrollToID('product-list');
        }
      }
    },

    // lista produktów,
    loadProductListItems: (e) => {
      const triggerBtn = e.delegateTarget || e.target;
      const url = triggerBtn.dataset.jsLoadProductListItems;
      e.preventDefault();
      sp.toggleSideMenu('product-filters');
      sp.productListLoaderOn();

      sp.syncPathSegments();

      // Build query string: put `page` first (taken from the clicked URL), then required params
      const urlQuery = url.includes('?') ? url.split('?')[1] : '';
      const currentPage = new URLSearchParams(urlQuery).get('page');

      const requiredParams = sp.getCurrentRequiredParams();
      const qs = new URLSearchParams();

      if (currentPage) {
        delete requiredParams.page;
        if (currentPage !== '1') {
          qs.append('page', currentPage);
        }
      }

      Object.keys(requiredParams).forEach((key) => {
        const value = requiredParams[key];
        if (Array.isArray(value)) {
          value.forEach((v) => qs.append(key, v));
        } else if (value !== undefined && value !== null && value !== '') {
          qs.append(key, value);
        }
      });

      const path = url.split('?')[0];
      const basePath = path.split('/').filter(Boolean)[0];

      const params = qs.toString();
      const fullPath = `/igroup/append/${basePath}/${Array.from(sp.pathSegments).join('/')}?${params}`;

      /*       console.log('path', path);
            console.log('segments', segments);
            console.log('basePath', basePath);
            console.log('pathSegments', sp.pathSegments);
            console.log('params', params);
            console.log('fullPath', fullPath); */

      // Lokalny licznik stron dla przycisku "Załaduj więcej" (start: z URL, zwykle 2)
      const loadNextBtnInit = document.querySelector('[data-js-load-product-list-items]');
      const initialUrl = loadNextBtnInit?.dataset?.jsLoadProductListItems || '';
      const initialPage = (() => {
        if (!initialUrl) return 2;
        const u = new URL(initialUrl, window.location.origin);
        const p = parseInt(u.searchParams.get('page') || '2', 10);
        return Number.isFinite(p) && p > 0 ? p : 2;
      })();
      let nextPage = initialPage;

      const cb = (content) => {
        sp.productListLoaderOff();

        const loadNextBtn = document.querySelector('[data-js-load-product-list-items]');
        if (triggerBtn instanceof HTMLElement) {
          triggerBtn.blur();
        }

        if (!loadNextBtn) {
          return;
        }

        // Jeśli backend nie zwrócił kontentu -> ukryj przycisk
        if (content === '') {
          loadNextBtn.classList.add('d-none');
          return;
        }

        // Jeżeli w kontencie jest mniej niż 30 produktów, to traktujemy to jako ostatnią stronę
        // (nieidealne, bo ostatnia strona może mieć dokładnie 30, ale o to chodzi)
        const productsCount = (content.match(/\bcard-product-wrapper\b/g) || []).length;
        if (productsCount > 0 && productsCount < 30) {
          loadNextBtn.classList.add('d-none');
          return;
        }

        // Jest kontent (i wygląda na to, że będą kolejne strony) -> przygotuj następną stronę
        nextPage += 1;
        loadNextBtn.classList.remove('d-none');

        const currentUrl = loadNextBtn.dataset.jsLoadProductListItems;
        if (!currentUrl) {
          return;
        }

        // URL jest zawsze w formacie: /produkty/... ?page=2&...
        const u = new URL(currentUrl, window.location.origin);
        u.searchParams.set('page', String(nextPage));

        // Zachowujemy format
        loadNextBtn.dataset.jsLoadProductListItems = `${u.pathname}${u.search}`;
      };
      triggerBtn.blur();
      sp.loadProductItems(fullPath, cb);
    },

    loadProductItems: (url, cb) => {
      if (!url) {
        return;
      }

      // Anuluj poprzednie żądanie (jeśli było)
      if (jsKit.currentAbortController) {
        jsKit.currentAbortController.abort();
      }

      // Stwórz nowy kontroler dla tego żądania
      jsKit.currentAbortController = new AbortController();
      const signal = jsKit.currentAbortController.signal;

      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
        },
        signal,
      })
        .then(res => {
          if (!res.ok) throw new Error('Fetch failed');
          return res.json();
        })
        .then((json) => {

          const element = document.querySelector('#product-list-items');
          if (element) {
            element.insertAdjacentHTML('beforeend', json.content);
          }
          if (cb) {
            cb(json.content);
          }
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            // OK, poprzednie żądanie zostało anulowane
            console.log('[loadWithHistory] Request aborted:', url);
          } else {
            console.error('[loadWithHistory] Error loading:', err);
          }
        });
    },

    // lista produktów,
    productListLoaderOn() {
      const productList = document.querySelector('#product-list');
      if (!productList) {
        return;
      }
      productList.classList.add('loading');
    },

    // lista produktów,
    productListLoaderOff() {
      const productList = document.querySelector('#product-list');
      if (!productList) {
        return;
      }
      productList.classList.remove('loading');
    },

    // strona główna - produkty
    loadProductsActiveBtn: (elem) => {
      elem.classList.remove('btn-light');
      elem.classList.add('btn-primary');

      const siblings = Array.from(elem.parentNode.children).filter(child => child !== elem);

      siblings.forEach((sibling) => {
        sibling.classList.add('btn-light');
        sibling.classList.remove('btn-primary');
      });
    },

    // strona główna hurt / detal - najnowsze produkty
    loadLatestProducts: async (e) => {
      const elem = e.target;
      const type = e.target.dataset.jsLoadLatestProducts;
      if (defaults.debugMode) {
        console.log(`loadLatestProducts(${type})`);
      }

      sp.loadProductsActiveBtn(elem);

      const panel = document.querySelector('#panel_latest_products');
      const url = `/main/loadLatestProducts/${type}`;

      const getCB = (data) => {
        if (data) {
          if (data.html) {
            panel.innerHTML = data.html;
          }
        }
      };

      await jsKit.fetchUrl(url, getCB);
    },

    // strona główna hurt / detal - najlepsze produkty
    loadBestProducts: async (e) => {
      const elem = e.target;
      const type = e.target.dataset.jsLoadBestProducts;
      if (defaults.debugMode) {
        console.log(`loadBestProducts(${type})`);
      }

      sp.loadProductsActiveBtn(elem);

      const panel = document.querySelector('#panel_best_products');
      const url = `/main/loadBestProducts/${type}`;

      const getCB = (data) => {
        if (data) {
          if (data.html) {
            panel.innerHTML = data.html;
          }
        }
      };

      await jsKit.fetchUrl(url, getCB);
    },

    toggleSideMenuClick: (e) => {
      if (defaults.debugMode) {
        console.log('toggleSideMenu()');
      }
      const elemId = e.target.dataset.asideMenu;
      sp.toggleSideMenu(elemId);
    },

    toggleSideMenu: (elemId) => {
      const sideMenu = document.getElementById(elemId);
      if (!sideMenu) {
        return;
      }
      if (sideMenu.classList.contains('shown')) {
        sideMenu.classList.remove('shown');
      } else {
        sideMenu.classList.add('shown');
      }
    },

    // strona główna detal - top10
    loadTopSaleProducts: async (e) => {
      const elem = e.target;
      const [attribute, option, smartGroup] = e.target.dataset.jsLoadTopSaleProducts.split(', ');
      if (defaults.debugMode) {
        console.log(`loadTopSaleProducts(${attribute}, ${option}, ${smartGroup})`);
      }

      sp.loadProductsActiveBtn(elem);

      const panel = document.querySelector(`#panel-top-sale-${attribute}-${option}`);
      const url = `/main/loadTopSaleProducts/${attribute}/${option}/${smartGroup || ''}`;

      const getCB = (data) => {
        if (data) {
          if (data.html) {
            panel.innerHTML = data.html;
            const swiperInstance = panel.parentElement.swiper;
            swiperInstance.slideTo(0);
          }
        }
      };

      await jsKit.fetchUrl(url, getCB);
    },
  };
})();

export default sp;
